<template>
	<div>
		<!-- Only for Booking Pending Txn -->
		<div v-if="vModel.StatusId == 24">
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">{{showMap ? 'Find Partners' : 'Booking Details'}}</h2>
				</div>
			</div>
			<div class="main-section mgt-40">
				<div class="container">

					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

						<div class="row">
							<div class="col-lg-8">
								<div v-if="showMap">
									<div v-if="showMap">
										<div class="form-card">
											<div class="form-card-header">
												<h3>Find eRemit Pay Partner Locations</h3>
											</div>
											<div class="form-card-forms">
												<GoogleMapDetail></GoogleMapDetail>
											</div>
										</div>

										<div class="submit-option">

											<div class="right-option">
												<button class="btn submit-righticon-btn" @click="onBackFromMap">
													<span class="btn-content">Back</span>
													<span class="right-icon">
														<i class="fas fa-angle-right"></i>
													</span>
												</button>
											</div>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="wrap-eremitpay-detail">
										<EremitPayDetail :vModel="vModel2"></EremitPayDetail>
									</div>
									<div class="submit-option" style="margin-bottom:5px">

										<div class="left-option">
											<button class="btn submit-righticon-btn" @click="loadMap()">
												<span class="btn-content">Find A Partner</span>
												<span class="right-icon">
													<i class="fas fa-map-marker"></i>
												</span>
											</button>
										</div>
										<div class="right-option">
											<router-link :to="'/transaction'" class="btn submit-righticon-btn">
												<span class="btn-content">Done</span>
												<span class="right-icon">
													<i class="fas fa-angle-right"></i>
												</span>
											</router-link>
										</div>
									</div>
								</div>

							</div>

							<div class="col-lg-4">
								<div class="sidebar">
									<img src="/static/img/icons/arrow-down-indicator-white.png" alt="" class="sidebar-arrow" />

									<h3 class="sidebar-header">Transfer Summary</h3>

									<hr />

									<div class="country-detail">
										<img :src="'/static/img/flags/'+vModel.Beneficiary.FlagCode+'.png'" alt="" />
										<h4>
											{{vModel.Beneficiary.FullName}}
											<br />
											<span class="country">{{vModel.Beneficiary.Country}}</span>
										</h4>
									</div>

									<hr />

									<div class="personal-detail">
										<ul>
											<li>
												<p>Payment Mode : </p>
												<h4>{{getPayMode(vModel.PaymodeId)}}</h4>
											</li>

											<li>
												<p>
													{{ vModel.PaymodeId == 1 ? "Bank Account Holder Name" : (vModel.PaymodeId == 2) ? "Beneficiary Name" : "Beneficiary Name"}}:
												</p>
												<h4 style="text-transform: uppercase;">
													{{vModel.Beneficiary.FullName}}
												</h4>
											</li>
											<li v-if="vModel.PaymodeId == 1">
												<p>Bank Account Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 1">
												<p>Bank Name :</p>
												<h4>{{vModel.Beneficiary.Bank}}</h4>
											</li>

											<li v-if="vModel.PaymodeId == 21">
												<p>Union Pay Card :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 22">
												<p>Wallet Number :</p>
												<h4>{{vModel.Beneficiary.BankAccount}}</h4>
											</li>
											<li v-if="vModel.PaymodeId == 2">
												<p>Agent :</p>
												<h4>{{vModel.Beneficiary.BankOrAgent}}</h4>
											</li>

										</ul>
									</div>

									<hr />

									<div class="amount-detail">
										<ul>
											<li>
												Transfer Amount (MYR) :
												<span>{{vModel.SendAmount}}</span>
											</li>
											<li>
												Exchange Rate :
												<span>{{vModel.ExchangeRate}}</span>
											</li>
											<li>
												Receive Amount ({{vModel.PayoutCurrency}}) :
												<span>{{vModel.PayoutAmount}}</span>
											</li>
											<li>
												Service Charge (MYR) :
												<span>{{vModel.TransferFee}}</span>
											</li>
											<li v-if="vModel.ShowGST">
												GST Charge (MYR) :
												<span>{{vModel.GST}}</span>
											</li>
											<li v-if="vModel.ShowPromoDiscount">
												Promotion Discount (MYR) :
												<span>-{{vModel.PromotionDiscount}}</span>
											</li>
										</ul>
										<div class="total-detail">
											<p>Total Transfer (MYR) :{{vModel.DepositedAmount}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div v-else>
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">Transaction Detail</h2>
				</div>
			</div>
			<div class="main-section mgt-40">
				<div class="container">
					<div class="main-card">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
						<div>

							<div class="form-card">
								<div class="form-card-header">
									<h3>
										Payment No.: {{vModel.TransactionRefNumber}} <span v-if="vModel.OldTransactionRefNumber != ''">
											Old Reference
											No: {{vModel.OldTransactionRefNumber}}
										</span>
									</h3>
								</div>
								<div class="form-card-forms">
									<div class="row m-b-sm">
										<div class="col">
											Deposited Amount (MYR)
										</div>
										<div class="col text-right">
											<b> {{vModel.DepositedAmount}}</b>
										</div>
									</div>
									<div class="row m-b-sm">
										<div class="col">
											Transfer Fee** (MYR)
										</div>
										<div class="col text-right">
											<b> {{vModel.TransferFee}}</b>
										</div>
									</div>
									<div class="row m-b-sm" v-if="vModel.ShowPromoDiscount">
										<div class="col">
											Promotion Discount (MYR)
										</div>
										<div class="col text-right">
											<b>-{{vModel.PromotionDiscount}}</b>
										</div>
									</div>
									<div v-if="vModel.ShowGST">
										<div class="row m-b-sm">
											<div class="col">
												Deposited Amount (MYR)
											</div>
											<div class="col text-right">
												<b> {{vModel.DepositedAmount}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												Transfer Fee** (MYR)
											</div>
											<div class="col text-right">
												<b> {{vModel.TransferFee}}</b>
											</div>
										</div>
									</div>
									<div v-if="vModel.PaymentMethodId == 98 || vModel.PaymentMethodId == 97">
										<div class="row m-b-sm">
											<div class="col">
												MTCN Number
											</div>
											<div class="col text-right">
												<b> {{vModel.MTCNNUmber}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												New Points Earned
											</div>
											<div class="col text-right">
												<b> {{vModel.NewPointsEarned}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												MyWU Number
											</div>
											<div class="col text-right">
												<b> {{vModel.WUNumber}}</b>
											</div>
										</div>
									</div>
									<div class="row m-b-sm">
										<div class="col">
											Exchange Rate (MYR-{{vModel.PayoutCurrency}})
										</div>
										<div class="col text-right">
											<b> {{vModel.ExchangeRate}}</b>
										</div>
									</div>
									<div class="row m-b-sm">
										<div class="col">
											Receiving Amount ({{vModel.PayoutCurrency}})
										</div>
										<div class="col text-right">
											<b> {{vModel.PayoutAmount}}</b>
										</div>
									</div>
									<hr />
									<div class="row m-b-sm">
										<div class="col">
											Source of funds
										</div>
										<div class="col text-right">
											<b> {{vModel.SourceOfFund}}</b>
										</div>

									</div>
									<div class="row m-b-sm">
										<div class="col">
											Payment purpose
										</div>
										<div class="col text-right">
											<b> {{vModel.PaymentPurpose}}</b>
										</div>

									</div>

									<div class="row m-b-sm" v-if="vModel.BonusLinkCardNumber != ''">
										<div class="col">
											BonusLink Card No.
										</div>
										<div class="col text-right">
											<b> {{vModel.BonusLinkCardNumber}}</b>
										</div>

									</div>

									<div class="row m-b-sm" v-if="vModel.PaymentMethodId ==1">
										<div class="col">
											FPX Id
										</div>
										<div class="col text-right">
											<b> {{vModel.FPXNumber}}</b>
										</div>
									</div>

									<div class="row m-b-sm" v-if="vModel.PaymodeId ==1 && (vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251)">
										<div class="col">
											Receiver Type
										</div>
										<div class="col text-right">
											<b> {{vModel.Beneficiary.ReceiverType}}</b>
										</div>
									</div>
									<div class="row m-b-sm" v-if="vModel.PaymodeId ==1 && vModel.Beneficiary.CountryId == 23">
										<div class="col">
											ABN No
										</div>
										<div class="col text-right">
											<b> {{vModel.Beneficiary.ABNNumber}}</b>
										</div>
									</div>
									<div class="row m-b-sm" v-if="vModel.PaymodeId ==1 && (vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251)">
										<div class="col">
											Company Type
										</div>
										<div class="col text-right">
											<b> {{vModel.Beneficiary.CompanyTypeDesc}}</b>
										</div>
									</div>
									<div class="row m-b-sm" v-if="vModel.PaymodeId ==1 && (vModel.Beneficiary.CountryId == 23 || vModel.Beneficiary.CountryId == 251)">
										<div class="col">
											Document Reference No
										</div>
										<div class="col text-right">
											<b> {{vModel.DocumentRefNumber}}</b>
										</div>
									</div>
								</div>
							</div>
							<div class="form-card">
								<div class="form-card-header">
									<h3>Your payment will be sent to</h3>
								</div>
								<div class="form-card-forms">

									<div class="row m-b-sm">
										<div class="col">
											<img :src="'/static/img/flags/'+vModel.Beneficiary.FlagCode+'.png'" />
											{{vModel.Beneficiary.FirstName}}
											{{vModel.Beneficiary.MiddleName}} {{vModel.Beneficiary.LastName}}
										</div>
									</div>
									<div v-if="vModel.PaymodeId ==1">
										<div class="row m-b-sm">
											<div class="col">
												Bank
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Bank}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												<p>Bank Account Number</p>
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>

									</div>
									<div v-else-if="vModel.PaymodeId ==21">
										<div class="row m-b-sm">
											<div class="col">
												Union Pay Card No.
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												Payout Name
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Agent}}</b>
											</div>

										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==22">
										<div class="row m-b-sm">
											<div class="col">
												Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==23">
										<div class="row m-b-sm">
											<div class="col">
												bKash Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==26">
										<div class="row m-b-sm">
											<div class="col">
												MCB Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==25">
										<div class="row m-b-sm">
											<div class="col">
												Wing Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==27">
										<div class="row m-b-sm">
											<div class="col">
												Weixin Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==30">
										<div class="row m-b-sm">
											<div class="col">
												Nagad Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.PaymodeId == 24 || vModel.PaymodeId == 28">
										<div class="row m-b-sm">
											<div class="col">
												eWallet Type
											</div>
											<div class="col text-right">
												<b> {{vModel.PaymodeId != 28 ? vModel.Beneficiary.Bank : vModel.Beneficiary.WalletType}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												<p>eWallet Number</p>
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>

										</div>

									</div>
									<div v-else-if="vModel.PaymodeId ==31 || vModel.PaymodeId ==32 || vModel.PaymodeId ==33">
										<div class="row m-b-sm">
											<div class="col">
												Wallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==97 || vModel.PaymodeId ==98">
										<div class="row m-b-sm">
											<div class="col">
												Receiver Mode
											</div>
											<div class="col text-right" v-if="vModel.PaymodeId ==97">
												<b>Western Union: Cash Pickup</b>
											</div>
											<div class="col text-right" v-else>
												<b>Western Union: Bank Account</b>
											</div>
										</div>
										<div class="row m-b-sm" v-if="vModel.ShowWesternUnionStatus">
											<div class="col">
												Western Union Status
											</div>
											<div class="col text-right">
												<b> {{vModel.WesternUnionStatus}}</b>
											</div>

										</div>
										<div class="row m-b-sm">
											<div class="col">
												MTCN Number
											</div>
											<div class="col text-right">
												<b> {{vModel.MTCNNUmber}}</b>
											</div>

										</div>

										<div v-if="vModel.PaymodeId ==98">
											<div class="row m-b-sm" v-for="(value, key) in vModel.D2BData">
												<div class="col">
													{{key}}
												</div>
												<div class="col text-right">
													<b> {{value}}</b>
												</div>

											</div>
										</div>

										<div class="row m-b-sm">
											<div class="col">
												Address
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Address}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												Country
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Country}}</b>
											</div>

										</div>

										<div v-if="vModel.ShowQuestionAnswer">
											<div class="row m-b-sm">
												<div class="col">
													Question
												</div>
												<div class="col text-right">
													<b> {{vModel.Question}}</b>
												</div>
											</div>
											<div class="row m-b-sm">
												<div class="col">
													Answer
												</div>
												<div class="col text-right">
													<b> {{vModel.Answer}}</b>
												</div>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.PaymodeId ==101 || vModel.PaymodeId ==102">
										<div class="row m-b-sm">
											<div class="col">
												Payment Mode
											</div>
											<div class="col text-right">
												<b>Visa: {{vModel.PaymentModeName}}</b>
											</div>

										</div>
										<div class="row m-b-sm">
											<div class="col">
												Visa Card Number
											</div>
											<div class="col text-right">
												<b>
													<img src="/static/img/icons/visa_logo.png" style="width:50px; margin-right:5px;">
													{{vModel.VisaCardNumber}}
												</b>
											</div>

										</div>
										<div class="row m-b-sm">
											<div class="col">
												Country
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Country}}</b>
											</div>

										</div>


										<div class="row m-b-sm">
											<div class="col">
												Contact Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.PhoneNumber}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												Relationship
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Relation}}</b>
											</div>
										</div>
									</div>
									<div v-else-if="vModel.Beneficiary.CountryId == 10 && (vModel.PaymodeId == 29 || vModel.PaymodeId == 1)">
										<div class="row m-b-sm" v-if="vModel.PaymodeId == 29">
											<div class="col">
												eWallet Type
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.WalletType}}</b>
											</div>
										</div>
										<div class="row m-b-sm" v-if="vModel.PaymodeId == 29">
											<div class="col">
												eWallet Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.BankAccount}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												Receiver Id Number
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.ReceiverIdNumber}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												Receiver Id Type
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.ReceiverIdTypeName}}</b>
											</div>
										</div>
									</div>
									<div v-else>

										<div class="row m-b-sm">
											<div class="col">
												Address
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Street}}</b>
											</div>

										</div>
										<div class="row m-b-sm">
											<div class="col">
												City
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.City}}</b>
											</div>
										</div>
										<div class="row m-b-sm">
											<div class="col">
												Payout Agent
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.Agent}}</b>
											</div>

										</div>
										<div class="row m-b-sm">
											<div class="col">
												Pickup Location
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.PickupLocation}}</b>
											</div>

										</div>

										<div class="row m-b-sm">
											<div class="col">
												Cash Pickup Pin
											</div>
											<div class="col text-right">
												<b> {{vModel.Beneficiary.CashPickupPin}}</b>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Only for Staging Transaction -->
							<div class="form-card" v-if="vModel.PaymentMethodId == 4">
								<div class="form-card-header">
									<h3>eRemit Pay - Pay at Store</h3>
								</div>
								<div class="form-card-forms">
									<div class="row m-b-sm">
										<div class="col">
											Booking Order Number
										</div>
										<div class="col text-right">
											<b> {{vModel.StagingOrderNumber}}</b>
										</div>
									</div>
									<div class="row m-b-sm">
										<div class="col">
											Partner Name
										</div>
										<div class="col text-right">
											<b> {{vModel.TerminalName || 'N/A'}}</b>
										</div>
									</div>
									<div class="row m-b-sm">
										<div class="col">
											Branch Code
										</div>
										<div class="col text-right">
											<b> {{vModel.BranchCode || 'N/A'}}</b>
										</div>
									</div>
								</div>
							</div>

							<div class="form-card">
								<div class="form-card-header">
									<h3>Payment Status</h3>
								</div>
								<div class="form-card-forms">
									<div class="row m-b-sm" v-for="notification in vModel.PaymentProgressList">
										<div class="col">
											{{notification.Status}}
										</div>
										<div class="col text-right">
											{{notification.StatusDate}}
										</div>
									</div>
									<div style="display:none;">
										<h2 class="m-t-lg">Comments</h2>
										<hr />
										<p>{{vModel.PaymentProgressComment}}</p>
									</div>

								</div>
							</div>

							<div class="form-card">
								<div class="form-card-header">
									<h3>Note:</h3>
								</div>
								<div class="form-card-forms">
									<ul v-if="!vModel.IsCreditNote">
										<li>
											<i>
												It is the sender's responsibility to notify the beneficiary on the
												Receiving Amount.
											</i>
										</li>
										<li>
											<i>
												It is the sender's responsibility to provide accurate information to
												facilitate successful
												remittance payout.
											</i>
										</li>
										<li>
											<i>
												This is a computer generated receipt and no signature is
												required.
											</i>
										</li>
									</ul>
									<ul v-if="vModel.IsCreditNote">
										<li>
											<i>
												It is the sender's responsibility to notify the beneficiary on the
												Receiving Amount.
											</i>
										</li>
										<li>
											<i>
												It is the sender's responsibility to provide accurate information to
												facilitate successful
												remittance payout.
											</i>
										</li>
										<li>
											<i>
												This is a computer generated receipt and no signature is
												required.
											</i>
										</li>
									</ul>

								</div>
							</div>

							<div class="row">
								<div class="col">

									<button v-if="!vModel.IsRefundEnabled && !vModel.IsReprocess && vModel.StatusId != 25 " class="btn btn-danger btn-icon btn-icon-standalone btn-icon-standalone btn-lg btn-invoice-creditnote" @click="downloadInvoice" type="button">
										<i class="fas fa-file-pdf-o"></i>
										<span>Download {{vModel.IsCreditNote ? 'Credit Note' : 'Invoice'}}</span>
									</button>

									<router-link v-if="vModel.StatusId == 12" :to="'/transaction/refund/'+vModel.TransactionRefNumber" class="btn btn-danger btn-lg btn-resend-refund">Refund</router-link>

									<router-link v-if="vModel.StatusId == 9 && (vModel.TypeofTraxId != 98 || vModel.TypeofTraxId != 97)" :to="'/recipient/merchantrade/edit/'+vModel.TypeofTraxId+'/'+vModel.Beneficiary.Id+'/'+vModel.TransactionRefNumber" class="btn btn-danger btn-lg btn-resend-refund">Reprocess</router-link>
									<router-link :to="'/transaction'" class="btn btn-default btn-lg btn-cancel">
										Cancel
									</router-link>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import TransactionService from "../../services/transaction";
	import {
		vueinstance
	} from "../../main";
	import FileSaver from "file-saver";
	import ListService from "../../services/list";
	import EremitPayDetail from "./eRemitPayDetail"
	import GoogleMapDetail from "./partnermap"

	export default {
		name: "transactiondetail",
		components: {
			EremitPayDetail,
			GoogleMapDetail
		},
		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(
				TransactionService.getDetail(to.params.txnrefno),
				ListService.get("list/refundbank")
			);

			Promise.all(promises).then(response => {
				next(p => {
					p.vModel = response[0].body;
					p.Banks = response[1].body;
					(p.RefundViewModel.TransactionRefNo = p.vModel.TransactionRefNumber),
						(p.RefundViewModel.RefundRemark = p.vModel.Remark);

					p.vModel2.StagingExpiryDate = response[0].body.StagingExpiryDate;
					p.vModel2.StagingOrderNumber = response[0].body.StagingOrderNumber;
					p.vModel2.StagingBarCodeUrl = response[0].body.StagingBarCodeUrl;
					p.vModel2.StagingPaymentRemainingTime = response[0].body.StagingPaymentRemainingTime;
					p.vModel2.CurrentDateTime = response[0].body.CurrentDateTime;

				});
			});
		},
		data() {
			return {
				show: false,
				showMap: false,
				Banks: null,
				RefundViewModel: {
					BankId: null,
					AccountNumber: null,
					AccountHolder: null,
					TransactionRefNo: null,
					RefundRemark: null
				},
				vModel: {
					PayoutAmount: null,
					SendAmount: null,
					SenderName: null,
					SenderAddress: null,
					BonusLinkCardNumber: null,
					IsBonusLinkCardNeeded: false,
					TransactionRefNumber: null,
					CreatedDate: null,
					TransactionStatus: null,
					IsReprocess: false,
					IsRefundEnabled: false,
					PaymodeId: null,
					Remark: null,
					SourceOfFund: null,
					PaymentPurpose: null,
					ExchangeRate: null,
					TransferFee: null,
					ShowGST: false,
					GST: null,
					DepositedAmount: null,
					PaymentProgressList: [],
					PaymentProgressComment: null,
					GSTPercentage: null,
					PayoutCurrency: null,
					FPXNumber: null,
					IsCreditNote: false,
					StatusId: null,
					PaymentMethodId: null,
					DocumentRefNumber: null,
					Beneficiary: {
						Id: 0,
						FirstName: null,
						MiddleName: null,
						LastName: null,
						CountryCode: null,
						Country: null,
						Currency: null,
						City: null,
						Street: null,
						PostCode: null,
						State: null,
						Bank: null,
						BankAccount: null,
						Agent: null,
						CashPickupPin: "",
						PickupLocation: null,
						ReasonRemark: null,
						RefundAmount: null,
						FlagCode: null,
						IsBonusLinkCardNeeded: false,
						BonusLink: null,
						PhoneNumber: null,
						ReceiverType: null,
						CompanyTypeDesc: null,
						ABNNumber: null
					},
					PaymentReference: null,
					OldTransactionRefNumber: null,
					Question: null,
					Answer: null,
					ShowQuestionAnswer: null
				},
				vModel2: {
					StagingExpiryDate: null,
					StagingOrderNumber: null,
					StagingBarCodeUrl: null,
					StagingPaymentRemainingTime: null,
					CurrentDateTime: null
				},
			};
		},

		methods: {
			onCancel: function () {
				this.$router.push("/transaction");
			},
			downloadInvoice: function () {
				var url = this.vModel.IsCreditNote ?
					"transaction/creditnote/" :
					"transaction/invoice/";
				this.$http
					.get(url + this.vModel.TransactionRefNumber, {
						responseType: "arraybuffer"
					})
					.then(response => {
						var blob = new Blob([response.body], {
							type: "application/pdf"
						});
						FileSaver.saveAs(blob, this.vModel.TransactionRefNumber + ".pdf");
					});
			},
			onRefund(event) {
				this.$router.push("/transaction/refund/" + this.vModel.TransactionRefNumber);
				/*this.errors.clear("refundForm");
				this.show = true;*/
			},
			OnOkSubmit(evt) {
				evt.preventDefault();
				this.onRefundSubmit();
			},
			onRefundCancel() {
				this.errors.clear("refundForm");
			},
			onRefundSubmit() {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll("refundForm").then(result => {
					if (result) {
						self.isProcessing = true;
						self.$http
							.post("transaction/refund/process", self.RefundViewModel)
							.then(
								response => {
									self.$toastr("success", "Refund Successfully");
									self.isProcessing = false;
									self.show = false;
									self.$router.push("/transaction");
								},
								error => {
									self.isProcessing = false;
								}
							);
					}
				});
			},
			loadMap() {
				this.showMap = true;
			},
			onBackFromMap() {
				this.showMap = false;
			},
			getPayMode(val) {
				return TransactionService.getPaymentMode(val);
			},
		}
	};
</script>

<style>
	.wrap-eremitpay-detail {
		padding-bottom: 170px;
	}

	.btn-invoice-creditnote {
		margin-right: 10px;
	}

	.btn-resend-refund {
		margin-right: 10px;
	}

	.btn-cancel {
		background: ButtonFace;
		margin-right: 10px;
	}
</style>
